import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";

import ProtectedRoute from "./components/ProtectedRoute";
import OtpAuthentication from "./apps/validationOTP";

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";
import AddContribuable from "./agent/contribuables/AddContribuable";


import { TokenProvider } from './context/TokenContext';

// import css
import "./assets/css/remixicon.css";

// import scss
import "./scss/style.scss";
import ContribuableDetails from "./agent/contribuables/ContribuableDetails";
import AgentsList from "./superAdmin/Agents";
import AgentDetails from "./agent/AgentDetails";
import CollectTaxPage from "./agent/contribuables/CollectTaxPage";
import EcheancesTaxPage from "./agent/contribuables/EcheancesTaxPage";
import AttenteValidationPage from "./agent/contribuables/AttenteValidationPage";
import CategoryDetails from "./admin/CategoryDetails";
import CategoryUsagersDetails from "./agent/contribuables/CategoryUsagersDetails";
import RechercheContribuable from "./agent/contribuables/searchContribuables";
import EditContribuable from "./agent/contribuables/EditContribuable";
import ActivitiesList from "./agent/contribuables/Activites";
import ActivityDetails from "./agent/contribuables/ActivityDetails.js";
import CollectePage from "./agent/contribuables/CollectePage.js";
import PaiementSuccesPage from "./agent/contribuables/PaiementSuccesPage.jsx";
import ForgotPassword from "./pages/ForgotPassword.js";
import ResetPasswordPage from "./pages/ResetPasswordPage.js";
import EntiteDetails from "./superAdmin/EntiteDetails.js";
import RobotsTxt from "./pages/RobotsTxt.js";
import AppVersionManagement from "./pages/AppVersionManagement.js";
import AddContribuableFromActivity from "./agent/contribuables/AddContribuableFromActivity.js";
import Marches from "./pages/gestion/Marches.jsx";
import MarketDashboard from "./pages/supervisor/MarketDashboard.jsx";
import ConsolidatedDashboard from "./pages/consolidated/ConsolidatedDashboard.jsx";
import AddAgent from "./superAdmin/AddAgent.jsx";
import EditAgent from "./superAdmin/EditAgent.jsx";
import AgentsPerformance from "./pages/supervisor/AgentsPerformance.jsx";
import Objectives from "./pages/supervisor/Objectives.jsx";
import NouveauMarche from "./pages/gestion/NouveauMarche.jsx";
import SalubriteAnalysis from "./pages/consolidated/SalubriteAnalysis.jsx";

import EnrolmentBonuses from "./agent/EnrolmentBonuses.js";
import MobilisationBonuses from "./agent/MobilisationBonuses.js";
import BonusHistory from "./agent/BonusHistory.js";
import FormesJuridiques from "./superAdmin/Formes.jsx";
import LoyerAnalysis from "./pages/consolidated/LoyerAnalysis.jsx";



// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {
  return (
    <React.Fragment>
      <TokenProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />}>
          <Route 
              index 
              element={<Navigate to="/login" replace />} 
            />
            
            {protectedRoutes.map((route, index) => {
              return (
                <>
                <Route
                  path={route.path}
                  element={route.element}
                  key={index}
                />
<Route path="/agent/contribuables/:id/edit" element={<EditContribuable />} />
                <Route path="/agent/ContribuableDetails/:id" element={<ContribuableDetails />} />
          
            <Route path="/agent/agent-details/:id" element={<AgentDetails />} />
            <Route path="/collect-tax/:taxId/:contribuableId" element={<CollectTaxPage />} />
            <Route path="/echeances-tax/:taxId/:contribuableId/:activityId" element={<EcheancesTaxPage />} />
            <Route path="/admin/CategoriesTaxes/:id" element={<CategoryDetails />} />
            <Route path="/admin/usager-categories/:code_category" element={<CategoryUsagersDetails />} />
            <Route path="/attente-validation/:transactionId" element={<AttenteValidationPage />} />



<Route path="/gestion/Marches" element={<Marches />} />
<Route path="/gestion/Marches/ajout" element={<Marches />} />


<Route path="/paiement-succes/:reference" element={<PaiementSuccesPage />} />
<Route path="/agent/contribuables/Activites" element={<ActivitiesList />} />
<Route path="/agent/contribuable/activities/:id" element={<ActivityDetails />} /> 

<Route path="/agent/contribuables/new" element={<AddContribuable />} />

<Route path="/collecte/:taxId/:contribuableId/:periodId" element={<CollectePage />} />

<Route path="/agent/contribuables/search" element={<RechercheContribuable />} />
<Route path="/superAdmin/entite/:id" element={<EntiteDetails />} />
<Route path="/superAdmin/app-versions" element={<AppVersionManagement />} />  
<Route path="/agent/contribuables/ajouter" element={<AddContribuableFromActivity />} />  


<Route path="/supervisor/dashboard" element={<MarketDashboard />} />
<Route path="/consolidated/dashboard" element={<ConsolidatedDashboard />} />


<Route path="/superAdmin/agent/new" element={<AddAgent />} />

<Route path="/superAdmin/Formes" element={<FormesJuridiques />} />
<Route path="/superAdmin/agents/edit/:id" element={<EditAgent />} />

<Route path="/supervisor/agents-performance" element={<AgentsPerformance />} />

<Route path="/supervisor/objectives" element={<Objectives />} />

<Route path="/consolidated/salubrite" element={<SalubriteAnalysis />} />

<Route path="/consolidated/loyers" element={<LoyerAnalysis />} />

<Route path="/gestion/marches/nouveau" element={<NouveauMarche />} />


<Route path="/superAdmin/AgentsFinance/Enrollement" element={<EnrolmentBonuses />} />
<Route path="/superAdmin/AgentsFinance/Mobilisation" element={<MobilisationBonuses />} />
<Route path="/superAdmin/AgentsFinance/Historique" element={<BonusHistory />} />


</>



                
              )
            })}
          </Route>
          {publicRoutes.map((route, index) => {
            return (
              <Route
                path={route.path}
                element={route.element}
                key={index}
              />
            )
          })}
          <Route path="*" element={<NotFound />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/robots.txt" element={<RobotsTxt />} />
        </Routes>
      </BrowserRouter>
      </TokenProvider>
    </React.Fragment>
    
  );
}